import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vModelText as _vModelText, withKeys as _withKeys, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-box__label"
}
const _hoisted_2 = {
  key: 0,
  class: "select-box__label-text"
}
const _hoisted_3 = { class: "select-box" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "container-first-load" }
const _hoisted_8 = { class: "container-first-load__loader" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "container-first-load" }
const _hoisted_12 = { class: "first-load-error-text" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 5,
  class: "container-first-load"
}
const _hoisted_15 = { class: "first-load-error-text" }

import { ref, watch, computed, onMounted, onUnmounted, nextTick, onUpdated } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { useSelectInputStore } from './useSelectInputStore';
import { storeToRefs } from 'pinia';
import {
  AggregateBusinessFilterProperty,
  FilterType,
  ForecastTimelineFilterProperty,
  isFetchRequiredFilterType,
} from '@/coreDomainsModule/entities/filter';
import { FilterInfoState } from './interface/uiState';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { FilterInfoRepository } from '@/coreInfrastructureModule/Repositories/FilterInfoRepository';
import { i18n } from '@/i18n';
import { SelectInputViewModel } from './selectInputViewModel';
import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';
import { FilterModalType } from '../filterModal/filterModal';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';

// FIXME: SelectInput周りは絶対に全部壊して作り直す

const MIN_SELECT_BOX_HEIGHT = 240;
const OPTION_HEIGHT = 32; // Height of one option item in pixels

/**
 * ドロップダウンの位置を計算し、設定します。
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSelectInput',
  props: {
    index: {},
    selectedRepresent: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean },
    filterType: {},
    isOpenProp: { type: Boolean, default: false },
    isError: { type: Boolean },
    errorMessage: { default: '' },
    isContinueOpening: { type: Boolean },
    propAggregateBusinessFilterProperty: { default: undefined },
    propCustomerForecastFilterProperty: { default: undefined },
    disableUnassignedColumn: { type: Boolean },
    propOptions: { default: () => [] as string[] },
    propPagingState: { default: undefined },
    propPagingOptions: { default: undefined },
    propOriginalOptions: { default: () => [] as string[] },
    useTeleport: { type: Boolean },
    filterModalType: { default: 'deletion-business' },
    resetButtonText: { default: undefined },
    useSearchInput: { type: Boolean, default: true },
    useReset: { type: Boolean, default: true },
    resetMode: { default: 'empty-option' },
    errorMessagePosition: { default: 'top' }
  },
  emits: ["click:selectInput", "update", "click:seeMore", "close", "selectedListResized", "reset", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isOpen = ref(false);
const t = i18n.t;
const store = useSelectInputStore(props.filterType, props.filterModalType, props.index)();
const { state } = storeToRefs(store);
const { $reset, setFilterInfo, fetchFilterInfo, searchItem } = store;
const isEllipsis = ref(false);

const filterInfoRepository = new FilterInfoRepository();
const vm = new SelectInputViewModel();

const emit = __emit;

const dropdownSelectedListDom = ref<HTMLDivElement | null>(null);

watch(
  () => props.isOpenProp,
  () => {
    isOpen.value = props.isOpenProp;
  }
);

watch(
  () => props.propOptions,
  () => {
    if (props.propOptions) {
      setFilterInfo(props.propOptions);
    }
  }
);

watch(
  () => props.propPagingState,
  () => {
    if (props.propPagingState) {
      state.value.pagingState = props.propPagingState;
    }
  }
);

watch(
  () => props.propPagingOptions,
  () => {
    if (props.propPagingOptions) {
      state.value.pagingOptions = props.propPagingOptions;
    }
  }
);

onMounted(() => {
  $reset();
});

/**
 * placeholderを表示するかどうか
 */
const isPlaceholder = computed(() => {
  return props.selectedRepresent === '' || props.selectedRepresent === null || props.selectedRepresent === undefined;
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
    if (!isOpen.value) {
      $reset();
    }
  }
};

/**
 * propsからオリジナルの選択肢リストを取得する。
 * @returns 正規化対象のオプション配列
 */
const getOriginalOptions = (): string[] => {
  if (props.propOriginalOptions && props.propOriginalOptions.length > 0) {
    return props.propOriginalOptions;
  }
  return props.propOptions ?? [];
};

/**
 * 選択肢を正規化して親にemitする。
 * @param option - 選択されたオプション
 * @param index - 選択肢が見つからなかった場合に使うフォールバックのインデックス
 */
const emitOption = (option: string, index?: number) => {
  const originalOptions = getOriginalOptions();
  const normalizedIndex = originalOptions.length > 0 ? originalOptions.indexOf(option) : index !== undefined ? index : undefined;
  emit('update', option, normalizedIndex !== undefined && normalizedIndex >= 0 ? normalizedIndex : index);
  if (!props.isContinueOpening) isOpen.value = false;
};

/**
 * 選択値をリセットします。
 */
const resetOption = () => {
  emit('reset');
  if (!props.isContinueOpening) isOpen.value = false;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = `#order-status-select-${props.index}`;
  const arrowSelector = `#order-status-select-arrow-${props.index}`;
  const searchSelector = `#order-status-select-search-${props.index}`;
  const dropDownSelector = `#order-status-select-dropdown-${props.index}`;
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.tagName === 'path' || target.tagName === 'svg') return; // 複数選択でのリスト内のxボタンを弾く
  if (target.closest(selector) && target.className.indexOf('select-box__confirm--button') < 0) return;
  if (target.closest(searchSelector)) return;
  if (target.closest(dropDownSelector)) return;

  isOpen.value = false;
  emit('close');
};

/**
 * 追加読み込み
 */
const onClickAppendButton = () => {
  fetchFilterInfo(props.propAggregateBusinessFilterProperty, props.propCustomerForecastFilterProperty);
  emit('click:seeMore');
};

/**
 * 再試行
 */
const onClickRetryButton = () => {
  fetchFilterInfo(props.propAggregateBusinessFilterProperty, props.propCustomerForecastFilterProperty);
  emit('click:seeMore');
};

/**
 * 検索トリガー
 * @param event - イベント
 */
const onSearchTrigger = (event?: Event) => {
  // ローディング中の場合と、日本語IMEの変換中は実行しない
  if (state.value.pagingState.type === 'loading' || (event instanceof KeyboardEvent && event.isComposing)) {
    return;
  }
  searchItem(props.propAggregateBusinessFilterProperty, props.propCustomerForecastFilterProperty, props.propOptions);
  emit('search', state.value.searchText);
};

const resizeObserver = new ResizeObserver((entries) => {
  emit('selectedListResized', entries[0].target.clientHeight);
});

onMounted(() => {
  document.addEventListener('click', closeDropdown);
  window.addEventListener('resize', calculateDropdownPosition);
  window.addEventListener('scroll', calculateDropdownPosition, true);
});

onUpdated(() => {
  if (dropdownSelectedListDom.value) resizeObserver.observe(dropdownSelectedListDom.value);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
  window.removeEventListener('resize', calculateDropdownPosition);
  window.removeEventListener('scroll', calculateDropdownPosition, true);
  if (dropdownSelectedListDom.value) resizeObserver.unobserve(dropdownSelectedListDom.value);
});

const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector(`#order-status-select-${props.index}`) as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector(`#order-status-select-dropdown-${props.index}`) as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left - 1}px`; // スクロールを考慮した絶対位置 MultipleSelectInputで使用した際に選択リストの背景色が見えてしまうので左に1pxずらしています
        dropdown.style.top = `${rect.bottom + 1}px`; // スクロールを考慮した絶対位置 若干セレクトボックスにかぶってしまうので1px下にずらしています
        dropdown.style.width = `${MIN_SELECT_BOX_HEIGHT > rect.width ? MIN_SELECT_BOX_HEIGHT : rect.width}px`; // select-boxの幅に合わせて設定

        // Calculate height based on 16 option items
        const desiredHeight = OPTION_HEIGHT * 16;

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`; // Set max height
        dropdown.style.overflowY = 'auto'; // スクロール可能にする
      }
    }
  });
};

/**
 * 読み込み中のテキストを取得するcomputed
 */
const loadingText = ref('読み込み中.');

let loadingInterval: number | undefined;

watch(isOpen, async (newVal) => {
  if (newVal) {
    emit('click:selectInput');
    calculateDropdownPosition();
    if (props.propOptions) {
      setFilterInfo(props.propOptions);
    }
    startLoadingAnimation();
    if (isFetchRequiredFilterType(props.filterType)) {
      await fetchFilterInfo(props.propAggregateBusinessFilterProperty, props.propCustomerForecastFilterProperty);
    }
  } else {
    $reset();
    stopLoadingAnimation();
  }
});

/**
 * ローディングアニメーションを開始します。
 */
const startLoadingAnimation = () => {
  loadingText.value = `${t('読み込み中')}.`; // Initialize with one dot
  loadingInterval = window.setInterval(() => {
    const dots = loadingText.value.match(/\./g)?.length || 0;
    loadingText.value = `${t('読み込み中')}${'.'.repeat((dots + 1) % 4)}`;
  }, 500);
};

/**
 * ローディングアニメーションを停止します。
 */
const stopLoadingAnimation = () => {
  if (loadingInterval) {
    clearInterval(loadingInterval);
    loadingInterval = undefined;
  }
};

/**
 * テキストにマウスオーバーしたときに、テキストが省略されているかどうかを判定する
 * @param e - イベント
 */
const mouseoverTextLabel = (e: MouseEvent) => {
  const { target } = e;
  if (!(target instanceof HTMLElement)) return;
  isEllipsis.value = target.offsetWidth < target.scrollWidth;
};

const data = computed(() =>
  state.value.pagingState.type === 'success'
    ? state.value.pagingState.data?.filter((d) => !props.disableUnassignedColumn || d !== UNASSIGNED_COLUMN)
    : []
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "select-box_container",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (closeDropdown($event)))
  }, [
    (_ctx.label !== '' || (_ctx.isError && _ctx.errorMessagePosition === 'top'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.label !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          _createVNode(ErrorMessage, {
            "is-error": _ctx.isError,
            "error-message": _ctx.errorMessage
          }, null, 8, ["is-error", "error-message"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$slots.selectedListTemplate ? 'select-box__selected--multiple' : 'select-box__selected--single')
      }, [
        _createElementVNode("div", {
          id: `order-status-select-${_ctx.index}`,
          class: _normalizeClass(["select-box__selected", { 'select-box__selected--disabled': _ctx.disabled, 'select-box__selected--error': _ctx.isError }]),
          onClick: toggleDropdown
        }, [
          (isEllipsis.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["select-box__field", { 'select-box__field--placeholder': isPlaceholder.value, 'select-box__field--disabled': _ctx.disabled }]),
                onMouseover: mouseoverTextLabel
              }, [
                _createTextVNode(_toDisplayString(isPlaceholder.value ? _ctx.placeholder : _unref(vm).displayValue(_ctx.filterType, _ctx.selectedRepresent)), 1)
              ], 34)), [
                [
                  _directive_tooltip,
                  _ctx.selectedRepresent,
                  void 0,
                  { bottom: true }
                ]
              ])
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["select-box__field", { 'select-box__field--placeholder': isPlaceholder.value, 'select-box__field--disabled': _ctx.disabled }]),
                onMouseover: mouseoverTextLabel
              }, _toDisplayString(isPlaceholder.value ? _ctx.placeholder : _unref(vm).displayValue(_ctx.filterType, _ctx.selectedRepresent)), 35)),
          (isOpen.value)
            ? (_openBlock(), _createBlock(SvgLoader, {
                key: 2,
                name: "arrowUp",
                class: "select-box__arrow"
              }))
            : (_openBlock(), _createBlock(SvgLoader, {
                key: 3,
                id: `order-status-select-arrow-${_ctx.index}`,
                name: "arrowDown",
                class: "select-box__arrow"
              }, null, 8, ["id"]))
        ], 10, _hoisted_4),
        _renderSlot(_ctx.$slots, "selectedListTemplate", {
          isOpen: isOpen.value,
          scroll: true
        })
      ], 2),
      (props.errorMessagePosition === 'bottom')
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            style: { justifySelf: 'start' },
            "is-error": _ctx.isError,
            "error-message": _ctx.errorMessage
          }, null, 8, ["is-error", "error-message"]))
        : _createCommentVNode("", true),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 1,
            to: "body",
            disabled: !_ctx.useTeleport
          }, [
            _createElementVNode("div", {
              id: `order-status-select-dropdown-${_ctx.index}`,
              class: "select-box__dropdown"
            }, [
              (props.useSearchInput)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: `order-status-select-search-${_ctx.index}`,
                    class: "select-box__search-box-container"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).searchText) = $event)),
                      class: "select-box__search-box",
                      type: "text",
                      onKeydown: _withKeys(onSearchTrigger, ["enter"])
                    }, null, 544), [
                      [_vModelText, _unref(state).searchText]
                    ]),
                    _createVNode(SvgLoader, {
                      name: "searchIcon",
                      class: "select-box__search-box-icon",
                      onClick: onSearchTrigger
                    })
                  ], 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_unref(state).pagingState.type === 'loading')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "select-box__option" }, null, -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(loadingText.value), 1)
                    ])
                  ], 64))
                : (_unref(state).pagingState.type === 'success')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.useReset)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "select-box__option",
                            onClick: resetOption
                          }, _toDisplayString(_ctx.resetButtonText ?? _unref(t)('選択を外す')), 1))
                        : _createCommentVNode("", true),
                      (!_unref(isFetchRequiredFilterType)(_ctx.filterType) && _unref(state).options.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(state).options, (option, optionIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option,
                              class: _normalizeClass(`select-box__option${_ctx.$slots.selectBoxOptionCheckboxTemplate ? ' select-box__option--inner' : ''}`),
                              onClick: ($event: any) => (emitOption(option, optionIndex))
                            }, [
                              _renderSlot(_ctx.$slots, "selectBoxOptionCheckboxTemplate", { option: option }),
                              _createTextVNode(" " + _toDisplayString(_unref(vm).displayValue(_ctx.filterType, option)), 1)
                            ], 10, _hoisted_9))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(data.value, (option, optionIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option,
                              class: _normalizeClass(`select-box__option${_ctx.$slots.selectBoxOptionCheckboxTemplate ? '   select-box__option--inner' : ''}`),
                              onClick: ($event: any) => (emitOption(option, optionIndex))
                            }, [
                              _renderSlot(_ctx.$slots, "selectBoxOptionCheckboxTemplate", { option: option }),
                              _createTextVNode(" " + _toDisplayString(_unref(vm).displayValue(_ctx.filterType, option)), 1)
                            ], 10, _hoisted_10))
                          }), 128))
                    ], 64))
                  : (_unref(state).pagingState.type === 'zeroMatch')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", {
                          class: "select-box__option",
                          onClick: resetOption
                        }, _toDisplayString(_ctx.resetButtonText ?? _unref(t)('選択を外す')), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('要素が１つも存在しません')), 1)
                        ])
                      ], 64))
                    : (_unref(state).pagingState.type === 'none' && !_unref(isFetchRequiredFilterType)(_ctx.filterType) && _unref(state).options.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (_ctx.useReset)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.resetMode === 'reset')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "select-box__option",
                                      onClick: resetOption
                                    }, _toDisplayString(_ctx.resetButtonText ?? _unref(t)('選択を外す')), 1))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "select-box__option",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emitOption('')))
                                    }))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).options, (option, optionIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option,
                              class: "select-box__option",
                              onClick: ($event: any) => (emitOption(option, optionIndex))
                            }, _toDisplayString(_unref(vm).displayValue(_ctx.filterType, option)), 9, _hoisted_13))
                          }), 128))
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('取得に失敗しました')), 1),
                          _createElementVNode("div", {
                            class: "select-box__option retry-button",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onClickRetryButton()), ["stop"]))
                          }, [
                            _cache[5] || (_cache[5] = _createTextVNode(_toDisplayString('再試行') + " ")),
                            _createVNode(SvgLoader, {
                              class: "calendar-select-button__retry-icon",
                              name: 'retryIcon',
                              "data-testid": "retry_icon"
                            })
                          ])
                        ])),
              _renderSlot(_ctx.$slots, "confirmButtonTemplate", {
                click: 
                () => {
                  isOpen.value = false;
                  emit('close');
                }
              
              }),
              _createElementVNode("div", {
                ref_key: "dropdownSelectedListDom",
                ref: dropdownSelectedListDom,
                class: "select-box__dropdown--list"
              }, [
                _renderSlot(_ctx.$slots, "selectedListTemplate", {
                  isOpen: isOpen.value,
                  scroll: false
                })
              ], 512)
            ], 8, _hoisted_5)
          ], 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})